import { render, staticRenderFns } from "./RemovePageConfirmation.vue?vue&type=template&id=0176f1c7&"
import script from "./RemovePageConfirmation.vue?vue&type=script&lang=js&"
export * from "./RemovePageConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports